// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Select, { GroupBase, Props as ReactSelectProps } from 'react-select';
import styles from './Select.module.scss'; // Import the SCSS stylesheet
import { cn } from '../../../utils/utils';

export type Option = {
  value: string;
  label: string;
  title?: string;
  type?: string;
};

type SelectProps<
  O = Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<O> = GroupBase<O>,
> = ReactSelectProps<O, IsMulti, Group> & {
  label?: string;
  error?: string;
  selectRef?: any;
};

const SelectComponent = <
  O extends unknown = Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<O> = GroupBase<O>,
>(
  props: SelectProps<O, IsMulti, Group>,
) => {
  const { isMulti, options, label, error, inputId, selectRef, ...otherProps } = props;

  return (
    <div className={styles['input']}>
      {label && (
        <label htmlFor={inputId} className={styles['label']}>
          {label}
        </label>
      )}
      <Select
        ref={selectRef}
        inputId={inputId}
        options={options}
        isMulti={isMulti}
        className={isMulti ? 'basic-multi-select' : 'basic-select'}
        classNames={{
          control: () => cn(styles['select__control'], error && styles['error']),
          dropdownIndicator: () => styles['dropdown_indicator'],
        }}
        classNamePrefix="select"
        {...otherProps}
      />
      {error ? <span className={styles['error-message']}>{error}</span> : null}
    </div>
  );
};

export default SelectComponent;
